export const statusList = [
    {value: 'CRIADO', label: "Criado"},
    {value: 'REGISTRADO', label: "Registrado"},
    {value: 'CANCELADO', label: "Cancelado"},
    {value: 'VENCIDO', label: "Vencido"},
    {value: 'PAGO', label: "Pago"},
    {value: 'EXPIRADO', label: "Expirado"},
    {value: 'ERRO', label: "Erro"},
    {value: 'EM_ALTERACAO', label: "Em alteração"},
]